export const extractFirstNElements = <T>(arr: Array<T>, number = 1) => {
  return arr.splice(0, number);
};
